






import Vue from "vue";
import Component from "vue-class-component";
import Tag from "@/components/form/Tag.vue";

@Component({
  props: {
    data: {
      required: true
    }
  },
  components: {
    Tag
  }
})
export default class CheckboxCellType extends Vue {}
